<template>
  <div class="visitor-counter-container">
    <div class="visitor-counter">
      <span class="label">Jumlah Pelawat:</span>
      <span class="count">{{ displayedCount }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useHttpService } from '@/httpService'

// Destructure the method from the composable
const { getVisitorCount } = useHttpService()
const count = ref(0)
const displayedCount = ref(0)

onMounted(async () => {
  // Call the function directly
  const data = await getVisitorCount()
  console.log('Visitor count data:', data)
  
  // Handle different potential response structures
  if (data && typeof data.count !== 'undefined') {
    count.value = data.count
  } else if (typeof data === 'number') {
    count.value = data
  } else {
    // Fallback if API fails or returns unexpected structure
    console.warn('Unexpected visitor count format', data)
    count.value = 1234
  }
  
  animateCount(count.value)
})

const animateCount = (target) => {
  const duration = 2000 // 2 seconds
  const startTime = performance.now()
  const start = 0

  const step = (timestamp) => {
    const elapsed = timestamp - startTime
    const progress = Math.min(elapsed / duration, 1)
    
    // Easing function for smooth animation
    const easeOutQuart = 1 - Math.pow(1 - progress, 4)
    
    displayedCount.value = Math.floor(easeOutQuart * (target - start) + start)

    if (progress < 1) {
      window.requestAnimationFrame(step)
    } else {
      displayedCount.value = target
    }
  }

  window.requestAnimationFrame(step)
}
</script>

<style scoped>
.visitor-counter-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
}

.visitor-counter {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 10px 20px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
}

.label {
  text-transform: uppercase;
  font-size: 0.9rem;
  opacity: 0.9;
}

.count {
  font-family: 'Courier New', Courier, monospace;
  font-size: 1.5rem;
  letter-spacing: 2px;
}
</style>
